var buildNumber = '1.0.0.0',
    systemLocate = System.locate;

// custom code to add build number to js files
// source: https://github.com/systemjs/systemjs/issues/1616#issuecomment-289268010

var buildNo = 'version=' + buildNumber
//SystemJSLoader$1 -> RegisterLoader$1 -> Loader
var Loader = System.__proto__.__proto__.__proto__.constructor;
var loaderResolve = Loader.prototype.resolve;
 
function augment(key) {
    if (key.indexOf(buildNo) > 0) {
        //key already augmented.
        return key;
    }
 
    var hI = key.indexOf("#"), qI = key.lastIndexOf("?", hI < 0 ? undefined : hI);
    if (qI > 0) {
        if (hI > 0) {
            //? and # found: put build between ? and #
            key = key.slice(0, hI) + "&" + buildNo + key.slice(hI);
        } else {
            //? found: put build at end
            key += "&" + buildNo;
        }
    } else {
        //no ? nor #
        key += "?" + buildNo;
    }
    return key;
}
 
var metadataSymbol;
function getMetadataSymbol(loader, mustFindKey) {
    if (metadataSymbol) {
        return metadataSymbol;
    }
    if (loader["@@metadata"]) {
        //some browsers dont support Symbol()
        return metadataSymbol = "@@metadata";
    }
    var symbols = Object.getOwnPropertySymbols(loader);
    for (var i = 0; i < symbols.length; i++) {
        var s = symbols[i], lov = loader[s];
        if (lov && typeof lov === 'object' && lov[mustFindKey]) {
            return metadataSymbol = s;
        }
    }
    throw new Error("I tried.");
}
 
Loader.prototype.resolve = function hackedLoaderResolve() {
    var loader = this;
    return Promise
            .resolve(loaderResolve.apply(loader, arguments))
            .then(function (key) {
                var newKey = augment(key);
                if (newKey !== key) {
                    var metaSymbol = getMetadataSymbol(loader, key);
                    var metadata = loader[metaSymbol];
                    var moveMe = metadata[key];
 
                    if (moveMe) {
                        delete metadata[key];
                        metadata[newKey] = moveMe;
                    }
                }
                return newKey;
            });
};

const whiteLabeledDomains = [
    "local.artemisfunds.com",
    'artemisfunds.com', 
    'www.artemisfunds.com', 
    'uat.artemisfunds.com',
    'test.artemisfunds.com', 
    'cd.test.nonprod.artemispubweb.com', 
    'cm.test.nonprod.artemispubweb.com', 
    'cd.uat.nonprod.artemispubweb.com', 
    'cm.uat.nonprod.artemispubweb.com'
];

System.config({
    baseURL: "/Assets/built/js",
    defaultJSExtensions: false,
    map: {
        'bootstrap': 'utils/bootstrap',
        'fa_require': '/Assets/built/libs/FA_require.js',
        'jquery': '/Assets/built/libs/jquery/dist/jquery.min.js',
        'lodash': '/Assets/built/libs/lodash/lodash.min.js',
        'slick': '/Assets/built/libs/slick-carousel/slick/slick.min.js',
        'parallel': '/Assets/built/libs/paralleljs/lib/parallel.js',
        'chroma': '/Assets/built/libs/chroma-js/chroma.min.js',
        'gmap': 'https://maps.googleapis.com/maps/api/js?v=3.exp' + (whiteLabeledDomains.indexOf(location.hostname) !== -1 ? '&key=AIzaSyAeavfWl7RswYuTjbREsFeRBrJmauwz14Y' : ''),
        'components': '/Assets/built/js/components'
    },
    meta: {
        'jquery': {
            format: 'amd'
        },
        'fa_require': {
            format: 'global',
            deps: [
              'jquery'
            ]
        },
        'chroma': {
            format: 'global',
            exports: 'chroma'
        },
        'parallel': {
            format: 'global',
            exports: 'Parallel'
        },
        'gmap': {
            format: 'global',
            exports: 'google',
            scriptLoad: true
        }
    },
    packages: {
        "components": {
            defaultExtension: 'js'
        },
        "controllers": {
            defaultExtension: 'js'
        },
        "templates": {
            defaultExtension: 'js'
        },
        "utils": {
            defaultExtension: 'js'
        },
        "helpers": {
            defaultExtension: 'js'
        }
    }

});
